export default context => {
    if (context === document) {
        $.fn.toggleStrBool = function(name) {
            return $(this).attr(name, $(this).attr(name) === "true" ? "false" : "true")
        }
        $.fn.cancellableTrigger = function(...args) {
            const e = jQuery.Event(...args)
            $(this).trigger(e)
            return !e.isDefaultPrevented()
        }
    }
}
